export function authReturnLocation(location) {
  return { pathname: location.pathname, search: location.search || '', hash: location.hash || '' };
}

export function authReturnDestination(from) {
  if (!from || typeof from.pathname !== 'string' || !from.pathname.startsWith('/') || from.pathname.startsWith('//')) return '/explore';
  return `${from.pathname}${typeof from.search === 'string' ? from.search : ''}${typeof from.hash === 'string' ? from.hash : ''}`;
}

/**
 * 「以訪客瀏覽」僅還原既有公開可讀路徑；其餘回探索，避免繞過 ProtectedRoute。
 */
export function guestBrowseDestination(from) {
  if (!from || typeof from.pathname !== 'string') return '/explore';
  const path = from.pathname;
  if (path.startsWith('//') || !path.startsWith('/')) return '/explore';
  const publicExact = new Set(['/explore', '/discover/journeys']);
  const publicPrefixes = [
    '/public/journeys',
    '/public/group-trips',
    '/social/posts/',
    '/social/creators/',
  ];
  const allowed = publicExact.has(path)
    || publicPrefixes.some((prefix) => path === prefix.replace(/\/$/, '') || path.startsWith(prefix));
  if (!allowed) return '/explore';
  return authReturnDestination(from);
}
